<template>
  <v-card class="mt-4 mb-6 pt-1 point-distances-card">
    <v-row>
      <v-col
        ><h4>{{ $t("tests.illumination.distance_card.wall.title") }}</h4>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <div class="caption black20">
            {{ $t("tests.illumination.distance_card.wall.left") }}
          </div>
          <div class="body2">
            {{ `${distanceFromLeftWall.toFixed(1)} ${$t("general.meter")}` }}
          </div>
        </v-row>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <div class="caption black20">
            {{ $t("tests.illumination.distance_card.wall.top") }}
          </div>
          <div class="body2">
            {{ `${distanceFromTopWall.toFixed(1)} ${$t("general.meter")}` }}
          </div>
        </v-row>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <div class="caption black20">
            {{ $t("tests.illumination.distance_card.wall.right") }}
          </div>
          <div class="body2">
            {{ `${distanceFromRightWall.toFixed(1)} ${$t("general.meter")}` }}
          </div>
        </v-row>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <div class="caption black20">
            {{ $t("tests.illumination.distance_card.wall.bottom") }}
          </div>
          <div class="body2">
            {{ `${distanceFromBottomWall.toFixed(1)} ${$t("general.meter")}` }}
          </div>
        </v-row></v-col
      >
      <v-col class="mr-4"
        ><h4>{{ $t("tests.illumination.distance_card.between.title") }}</h4>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <div class="caption black20">
            {{ $t("tests.illumination.distance_card.between.vertical") }}
          </div>
          <div class="body2">
            {{
              `${distance_between_points_y.toFixed(1)} ${$t("general.meter")}`
            }}
          </div>
        </v-row>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <div class="caption black20">
            {{ $t("tests.illumination.distance_card.between.horizontal") }}
          </div>
          <div class="body2">
            {{
              `${distance_between_points_x.toFixed(1)} ${$t("general.meter")}`
            }}
          </div>
        </v-row>
        <v-row class="mx-0 my-3 d-flex justify-space-between">
          <h4>{{ $t("tests.illumination.distance_card.between.height") }}</h4>
          <div class="body2">
            {{ `${measurement_height} ${$t("general.meter")}` }}
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "point-distances-card",
  computed: {
    ...mapState("roomStore", [
      "measurement_height",
      "distance_between_points_x",
      "distance_between_points_y",
      "corners",
      "measurement_points",
      "selected_measurement_point_id",
      "longer_size_length",
    ]),
    pointMeasuredCoordinates() {
      const pointMeasured = this.measurement_points.find(
        (point) =>
          point.measurement_point_id === this.selected_measurement_point_id
      );
      return {
        x: pointMeasured.x,
        y: pointMeasured.y,
      };
    },
    cornerObjects() {
      const objects = [];
      for (let i = 0; i < this.corners.length - 1; i = i + 2) {
        objects.push({
          x: this.corners[i],
          y: this.corners[i + 1],
        });
      }
      return objects;
    },
    pixelsInMeter() {
      const xInPixels =
        Math.max(...this.cornerObjects.map((corner) => corner.x)) -
        Math.min(...this.cornerObjects.map((corner) => corner.x));
      const yInPixels =
        Math.max(...this.cornerObjects.map((corner) => corner.y)) -
        Math.min(...this.cornerObjects.map((corner) => corner.y));
      return Math.max(xInPixels, yInPixels) / this.longer_size_length;
    },
    distanceFromLeftWall() {
      return (
        (this.pointMeasuredCoordinates.x -
          Math.min(...this.cornerObjects.map((corner) => corner.x))) /
        this.pixelsInMeter
      );
    },
    distanceFromTopWall() {
      return (
        (this.pointMeasuredCoordinates.y -
          Math.min(...this.cornerObjects.map((corner) => corner.y))) /
        this.pixelsInMeter
      );
    },
    distanceFromRightWall() {
      return (
        (Math.max(...this.cornerObjects.map((corner) => corner.x)) -
          this.pointMeasuredCoordinates.x) /
        this.pixelsInMeter
      );
    },
    distanceFromBottomWall() {
      return (
        (Math.max(...this.cornerObjects.map((corner) => corner.y)) -
          this.pointMeasuredCoordinates.y) /
        this.pixelsInMeter
      );
    },
  },
};
</script>

<style lang="scss">
.point-distances-card {
  background-color: rgba(255, 255, 255, 0.1) !important;
  min-height: 178px;
  border-radius: 4px;
  padding: 8px 22px;
}
</style>
